<template>
    <div v-sortable="{ onEnd: onUpdate, handle: '.handle', group: 'lessons' }" v-bind:data-module-id="moduleId" style="min-height:10px;">
        <template v-if="items && items.length > 0">
            <div class="slat m-t-2 m-b-1 slat-draggable slat-product-lesson" v-for="item in items" v-bind:key="item.item_type + '-' + item.id" v-bind:data-encoded-id="item.encoded_id" v-bind:data-model="itemModelClass(item)">
                <div class="row row-compress row-middle br p-t-3 p-b-3" v-bind:class="{'slat-draft': item.status === 'draft'}">
                    <div class="slat-controls m-vertical-none m-l-2">
                        <span class="m-r-2 i-container i-filled-dark">
                            <span class="handle">
                                <!-- /icons/drag.svg -->
                                <svg class="icon i-size-small inline icon-drag" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g transform="translate(8 3)" fill-rule="evenodd" class="icon"><rect width="3" height="3" rx="1.5"/><rect x="5" width="3" height="3" rx="1.5"/><rect y="5" width="3" height="3" rx="1.5"/><rect x="5" y="5" width="3" height="3" rx="1.5"/><rect y="10" width="3" height="3" rx="1.5"/><rect x="5" y="10" width="3" height="3" rx="1.5"/><rect y="15" width="3" height="3" rx="1.5"/><rect x="5" y="15" width="3" height="3" rx="1.5"/></g></svg>
                            </span>
                        </span>
                        <span class="control-group">
                            <div class="inline">
                                <label class="control control-checkbox block c-muted f-s-3 m-b-0 p-l-1">
                                    <input v-bind:checked="isSelected(item)" v-on:change="toggleSelected(item)" type="checkbox" />
                                    <div class="control-indicator control-checkbox-indicator"></div>
                                </label>
                            </div>
                        </span>
                    </div>
                    <div class="slat-figure--small column">
                        <a v-bind:href="itemEditLink(item)" class="block">
                            <img v-if="item.item_type === 'lesson'" v-bind:src="getLessonThumbnail(item)" v-original-fallback />
                            <img v-else-if="item.image" v-bind:src="item.image_url.thumbnail" v-original-fallback />
                            <div v-else class="quiz-thumbnail-placeholder c-accent-bg-light">
                                <span class="i-container i-filled-theme">
                                    <svg class="icon i-size-small" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path class="icon" d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm0 15.5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5zm1.02-5.62c-.5.38-.77.68-.77 1.12h-2c0-1.1.6-1.9 1.32-2.44.55-.41.93-.73.93-1.31 0-.72-.58-1.25-1.5-1.25-.83 0-1.5.53-1.5 1.5h-2c0-1.93 1.43-3.5 3.5-3.5 1.93 0 3.5 1.32 3.5 3.25 0 1.16-.62 1.93-1.48 2.63z"/></svg>
                                </span>
                            </div>
                        </a>
                    </div>
                    <div class="slat-content column">
                        <a v-bind:href="itemEditLink(item)" class="f-s-3 m-b-0 f-w-bold block">
                            <span class="c-primary">{{ itemTitle(item) }}</span>
                            <span class="i-container i-filled-dark m-r-2">
                                <!-- /icons/edit.svg -->
                                <svg class="icon m-b-1 m-l-2 i-size-small" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M15.7 4.3c-.4-.4-1-.4-1.4 0l-10 10c-.2.2-.3.4-.3.7v4c0 .6.4 1 1 1h4c.3 0 .5-.1.7-.3l10-10c.4-.4.4-1 0-1.4l-4-4zM8.6 18H6v-2.6l6-6 2.6 2.6-6 6zm7.4-7.4L13.4 8 15 6.4 17.6 9 16 10.6z" class="icon"/></svg>
                            </span>
                            <span v-if="item.status === 'draft'" class="badge c-muted-dim-bg c-bright f-w-bold f-caps m-r-4">{{ trans('Draft') }}</span>
                            <span v-if="item.item_type === 'quiz'" class="badge c-bright c-accent-tint-bg f-w-bold m-r-4">{{ item.questions_count }} {{ trans('questions') }}</span>
                        </a>
                    </div>
                    <div class="slat-aside text-right m-r-4">
                        <!--<a v-if="item.item_type === 'lesson'" v-on:click.prevent="changePreviewStatus(item, item.preview_enabled ? 0 : 1)" href="#lesson-preview">
                            <span class="tooltip animate m-3">
                                <span v-bind:class="{'i-filled-dark': ! item.preview_enabled, 'i-filled-theme': item.preview_enabled}" class="i-container">
                                    <svg class="icon m-b-1 m-l-2 i-size-tiny" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="#6F6FFF" class="icon"><path d="M15.99 10.042c.002-.073-.012-.142-.025-.212-.009-.044-.002-.088-.017-.132C14.713 5.991 11.519 3.5 8 3.5S1.287 5.991.052 9.698a1 1 0 1 0 1.897.633C2.911 7.441 5.344 5.5 8 5.5c2.541 0 4.863 1.788 5.904 4.473a11.21 11.21 0 0 1-.661.94 1 1 0 1 0 1.598 1.203c.417-.555.807-1.081 1.049-1.648l.007-.015c.011-.024.024-.048.034-.072.018-.045.014-.092.024-.139.016-.066.033-.13.035-.2z"/><path d="M8 5.515c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zm0 5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5z"/></g></svg>
                                </span>
                                <span class="tooltip-content tooltip-item tooltip--top">{{ trans('Make Free Preview') }}</span>
                            </span>
                        </a>-->
                        <a href="#item-publish" v-on:click.prevent="changePublishStatus(item, item.status === 'draft' ? 'published' : 'draft')">
                            <span class="tooltip animate">
                                <span class="i-container" v-bind:class="{'i-filled-dark': item.status === 'draft', 'i-filled-theme': item.status === 'published'}">
                                    <!-- /icons/s-checked.svg -->
                                    <svg class="icon m-b-1 m-l-2 i-size-tiny" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="#6F6FFF" class="icon" d="M7.5 11.5l-.056-.002a1.004 1.004 0 0 1-.726-.373l-2-2.5a1.002 1.002 0 0 1 1.563-1.25l1.302 1.628 5.59-5.591a.999.999 0 1 1 1.414 1.414l-6.38 6.381a.993.993 0 0 1-.707.293z"/><path fill="#6F6FFF" class="icon" d="M7.999 15.058a7.057 7.057 0 0 1-7.05-7.05c0-3.887 3.162-7.049 7.05-7.049 1.391 0 2.737.405 3.895 1.171a1 1 0 1 1-1.104 1.668 5.056 5.056 0 0 0-7.841 4.21c0 2.784 2.266 5.05 5.05 5.05s5.05-2.266 5.05-5.05a1 1 0 1 1 2 0 7.057 7.057 0 0 1-7.05 7.05z"/></svg>
                                </span>
                                <span class="tooltip-content tooltip-item tooltip--top">{{ trans('Publish') }}</span>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import Orderable from '../mixins/Orderable.js';
import { EventBus } from '../event-bus.js';
import { lessonEditLink, lessonDeleteLink, lessonPublishLink, lessonPreviewLink, lessonCloneLink, quizEditLink, quizPublishLink, quizDeleteLink } from '../routes.js';

export default {
    mixins: [Orderable],
    props: {
        items: {
            type: Array
        },
        checked: {
            type: Array,
            default: function() {
                return [];
            }
        },
        moduleId: {
            type: Number
        }
    },
    data() {
        return {
            model: 'Kourses\\Lesson',
            orderableParentKey: 'module_id',
        }
    },
    methods: {
        itemKey(item) {
            return item.item_type + '-' + item.id;
        },
        itemModelClass(item) {
            return item.item_type === 'quiz' ? 'Kourses\\Models\\Quiz' : 'Kourses\\Lesson';
        },
        itemTitle(item) {
            return item.item_type === 'quiz' ? item.title : item.name;
        },
        itemEditLink(item) {
            return item.item_type === 'quiz' ? quizEditLink(item) : lessonEditLink(item);
        },
        isSelected(item) {
            return _.indexOf(this.checked, this.itemKey(item)) >= 0;
        },
        toggleSelected(item) {
            let checked = this.checked;
            let index = _.indexOf(checked, this.itemKey(item));

            if (index < 0) {
                checked.push(this.itemKey(item));
            } else {
                checked.splice(index, 1);
            }

            this.$emit('update:checked', checked);
        },
        changePublishStatus(item, status) {
            let link = item.item_type === 'quiz' ? quizPublishLink(item) : lessonPublishLink(item);
            let previousStatus = item.status;

            item.status = status;

            let request = status === 'published'
                ? window.axios.put(link)
                : window.axios.delete(link);

            request
                .then((response) => {
                    item.status = response.data.status;
                })
                .catch((error) => {
                    item.status = previousStatus;
                    this.$toast.danger(error.response.data.message);
                });
        },
        changePreviewStatus(item, status) {
            // Lessons only — quizzes have no preview concept
            item.preview_enabled = status;
            if (status) {
                window.axios
                    .put(lessonPreviewLink(item))
                    .then((response) => {
                        item.preview_enabled = response.data.preview_enabled;
                    });
            } else {
                window.axios
                    .delete(lessonPreviewLink(item))
                    .then((response) => {
                        item.preview_enabled = response.data.preview_enabled;
                    });
            }
        },
        deleteItem(item) {
            let link = item.item_type === 'quiz' ? quizDeleteLink(item) : lessonDeleteLink(item);

            window.axios
                .delete(link)
                .then(() => {
                    this.items.splice(_.findIndex(this.items, (existing) => {
                        return this.itemKey(existing) === this.itemKey(item);
                    }), 1);
                });
        },
        cloneLessons(selectedLessons) {
            return window.axios
                .post(lessonCloneLink(), { lessons: selectedLessons })
                .then((response) => {
                    for (let lesson of response.data) {
                        this.items.splice(lesson.order - 1, 0, Object.assign({}, lesson, { item_type: 'lesson' }));
                    }
                });
        },
        getLessonThumbnail(lesson) {
            if (lesson.image) {
                return lesson.image_url.thumbnail;
            } else if (lesson.video_image_url) {
                return lesson.video_image_url;
            }

            return '/img/placeholder-image.png';
        },
    },
    mounted() {
        const $vm = this;

        // Listen for lessons added in "bulk"
        EventBus.$on('lessons:added', (moduleWithLessons) => {
            if ($vm.moduleId !== parseInt(moduleWithLessons.id)) {
                return;
            }

            for (let lesson of moduleWithLessons.lessons) {
                $vm.items.push(Object.assign({}, lesson, { item_type: 'lesson' }));
            }
        });
    }
}
</script>
<style scoped>
.quiz-thumbnail-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    aspect-ratio: 16 / 9;
    border-radius: 4px;
}
</style>
